





















import YellowConfirmation from "@/components/YellowConfirmation.vue";
import { ConfirmationMixin } from "@/mixins/confirmation";

import eventBus from "@/services/eventBus";
import store, { InvoiceFlowStore } from "../services/InvoiceFlowStore";
import wizardStore, { InvoiceWizardStore } from "@/modules/invoiceFlowTask/services/InvoiceTaskWizard";
import { t } from "@/plugins/i18n";

interface Data {
  store: InvoiceFlowStore;
  wizardStore: InvoiceWizardStore;
}

interface Computed {
  id: number;
}

interface Props {
  buttonText: string;
  incorrectCols: string;
  disabled: boolean;
  align: string;
  prefix: string;
  backPath: string;
  notFlow: boolean;
  otherConfirmation: string;
  customText: string;
}

export default ConfirmationMixin.extend<Data, {}, Computed, Props>({
  components: { YellowConfirmation },

  props: {
    buttonText: { type: String, default: t("HibasRogzites") },
    incorrectCols: { type: String, default: "auto" },
    disabled: { type: Boolean, default: false },
    align: { type: String, default: "right" },
    prefix: { type: String, default: "GENI" },
    backPath: { type: String, default: "/" },
    notFlow: { type: Boolean, default: false },
    otherConfirmation: { type: String, default: "" },
    customText: String,
  },

  mixins: [ConfirmationMixin],

  data: () => ({
    store,
    wizardStore,
  }),

  computed: {
    id() {
      return !this.notFlow ? this.store.invoice.id : Number(this.$route.params.invoiceId) || 0;
    },
  },

  methods: {
    async setIncorrect() {
      const text = this.customText
        ? this.customText
        : t("InvoiceFlow_BiztosHogyHibasRogzitesreAllitjaA", [this.notFlow ? "" : this.prefix + ": ", this.id]);
      const confirmed = await this.confirm(text, t("InvoiceFlow_SetIncorrect"));
      if (!confirmed) return;

      let confirmedOther = true;

      if (this.otherConfirmation != "") {
        // timeout for the other confirmation to appear
        await setTimeout(() => {
          return;
        }, 10);
        confirmedOther = await this.confirm(this.otherConfirmation, t("InvoiceFlow_SetIncorrect"));
      }
      if (!confirmedOther) return;

      if (this.notFlow) {
        this.$emit("confirmed");
        return;
      }

      await this.store.setIncorrect().then(() => {
        this.$invoiceTaskUpdateHub.send("InvoiceTaskUpdated");
      });

      eventBus.$emit("success", t("HibasRogzitesStatuszFrissitve"));

      if (this.wizardStore?.wizard?.hasItems) {
        this.store.isEditingEnabled = false;
        return;
      }

      if (this.backPath != "") this.$router.push(`${this.backPath}`);
    },
  },
});
